import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-chip-option',
  standalone: true,
  host: {
    '[class.selected]': 'selected()',
    '[class.disabled]': 'disabled()',
  },
  template: `
    <span class="check-icon" [class.visible]="selected()" aria-hidden="true">
      <span class="material-symbols-outlined">check</span>
    </span>
    <span class="chip-label">{{ label() }}</span>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        height: 32px;
        padding: 0 16px 0 8px;
        border-radius: 8px;
        border: 1px solid var(--md-sys-color-outline-variant);
        background: transparent;
        color: var(--md-sys-color-on-surface-variant);
        cursor: pointer;
        outline: none;
        user-select: none;
        transition: all var(--md-sys-motion-standard-effects-fast);
        position: relative;

        &:focus-visible {
          outline: 3px solid var(--md-sys-color-secondary);
          outline-offset: 2px;
        }

        &:hover:not(.disabled) {
          &::before {
            content: '';
            position: absolute;
            inset: 0;
            background: var(--md-sys-color-on-surface-variant);
            opacity: 0.08;
            border-radius: inherit;
          }
        }

        &.selected {
          border-color: transparent;
          background: var(--md-sys-color-secondary-container);
          color: var(--md-sys-color-on-secondary-container);

          &:hover:not(.disabled)::before {
            background: var(--md-sys-color-on-secondary-container);
          }
        }

        &.disabled {
          cursor: not-allowed;
          opacity: 0.38;
        }
      }

      .check-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        visibility: hidden;

        &.visible {
          visibility: visible;
        }

        .material-symbols-outlined {
          font-size: 18px;
          font-variation-settings:
            'FILL' 0,
            'wght' 400,
            'GRAD' 0,
            'opsz' 24;
          color: var(--md-sys-color-on-secondary-container);
        }
      }

      .chip-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipOptionComponent {
  label = input.required<string>();
  selected = input<boolean>(false);
  disabled = input<boolean>(false);
}
